const PENDING_MODAL_KEY = 'partner:pendingMembershipModal';
const REOPEN_MODAL_KEY = 'partner:reopenMembershipModal';
const MEMBERSHIP_CHECKOUT_KEY = 'partner:membershipCheckoutStarted';

export const PARTNER_PROFILE_ROUTE = { name: 'navigation.profile' };

export const stashPendingPartnerMembershipModal = (query = {}) => {
  sessionStorage.setItem(PENDING_MODAL_KEY, JSON.stringify({
    checkout: query.checkout || '',
    sessionId: query.session_id || query.sessionId || '',
  }));
};

export const peekPendingPartnerMembershipModal = () => {
  try {
    const raw = sessionStorage.getItem(PENDING_MODAL_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    return parsed;
  } catch {
    return null;
  }
};

export const clearPendingPartnerMembershipModal = () => {
  sessionStorage.removeItem(PENDING_MODAL_KEY);
};

export const markPartnerMembershipModalReopen = () => {
  sessionStorage.setItem(REOPEN_MODAL_KEY, '1');
};

export const consumePartnerMembershipModalReopen = () => {
  const reopen = sessionStorage.getItem(REOPEN_MODAL_KEY) === '1';
  sessionStorage.removeItem(REOPEN_MODAL_KEY);
  return reopen;
};

export const markPartnerMembershipCheckoutStarted = () => {
  sessionStorage.setItem(MEMBERSHIP_CHECKOUT_KEY, '1');
  markPartnerMembershipModalReopen();
  stashPendingPartnerMembershipModal({});
};

export const isPartnerMembershipCheckoutStarted = () => (
  sessionStorage.getItem(MEMBERSHIP_CHECKOUT_KEY) === '1'
);

export const consumePartnerMembershipCheckoutStarted = () => {
  const started = sessionStorage.getItem(MEMBERSHIP_CHECKOUT_KEY) === '1';
  sessionStorage.removeItem(MEMBERSHIP_CHECKOUT_KEY);
  return started;
};

export const syncPartnerMembershipCheckoutFromLocation = (readLocationCheckoutQuery) => {
  if (typeof window === 'undefined' || typeof readLocationCheckoutQuery !== 'function') {
    return false;
  }
  if (!window.location.pathname.includes('/navigation/membership')) return false;
  const query = readLocationCheckoutQuery();
  if (!query?.checkout) return false;
  stashPendingPartnerMembershipModal(query);
  return true;
};
